"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SectionProducts;
(function (SectionProducts) {
    SectionProducts["FVS"] = "Forensic and Valuation Services (FVS) Section";
    SectionProducts["NFP"] = "Not-for-Profit (NFP) Section";
})(SectionProducts = exports.SectionProducts || (exports.SectionProducts = {}));
//# sourceMappingURL=product-section.js.map